module.exports = __webpack_public_path__ + "static/media/spray-can.109153e3.svg";